module.exports = __webpack_public_path__ + "img/casino-micro.aecc18e3.jpg";